module.exports = __webpack_public_path__ + "img/brackets-round.e4f0b39b.svg";